var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewNote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2C12.3009 2.04488 8.76597 3.53429 6.15013 6.15013C3.53429 8.76597 2.04488 12.3009 2 16C2.04488 19.6991 3.53429 23.234 6.15013 25.8499C8.76597 28.4657 12.3009 29.9551 16 30C19.6991 29.9551 23.234 28.4657 25.8499 25.8499C28.4657 23.234 29.9551 19.6991 30 16C29.9551 12.3009 28.4657 8.76597 25.8499 6.15013C23.234 3.53429 19.6991 2.04488 16 2ZM24 17H17V24H15V17H8V15H15V8H17V15H24V17Z",
    fill: "#6F6F67"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewNote);
export default __webpack_public_path__ + "static/media/new-note.d916edcd7a75e6a816b0da986adc5efb.svg";
export { ForwardRef as ReactComponent };